import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import yobsti_logo from '@/public/img/logo.png';
import products from '@/public/svg/products.svg';
import customers from '@/public/svg/market.svg';
import about from '@/public/svg/users.svg';
import suppliers from '@/public/svg/delivery.svg';
import locations from '@/public/svg/location.svg';
import cancel from '@/public/svg/close.svg';
import menu from '@/public/svg/menu.svg';
import WhatsAppButton from '@/components/UI/WhatsAppButton';
import { WHATSAPP_CHAT_URL } from '@/data/contact';
import { track } from '@/helpers/analytics';

const navItems = [
  { to: '/', icon: products, label: 'Angebote & Produkte' },
  { to: '/fuer-kunden', icon: customers, label: 'Für Kunden' },
  { to: '/fuer-lieferanten', icon: suppliers, label: 'Für Lieferanten' },
  { to: '/ueber-uns', icon: about, label: 'Über uns' },
  { to: '/standorte', icon: locations, label: 'Standorte' },
];

const Header: React.FC = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const linkBase =
    "flex items-center gap-2 hover:text-primaryDark transition font-semibold";
  const activeUnderline = ({ isActive }: { isActive: boolean }) =>
    `${linkBase} border-b-2 pb-1 ${isActive ? "border-lineGreen" : "border-transparent"
    }`;
  return (
    <header className="w-full bg-white border-b border-[#DFDED1] relative z-50">
      <div className="mx-auto max-w-7xl px-5 sm:px-10">
        <div className="flex items-center justify-between h-16">
          <NavLink to="/" className="flex items-center">
            <img
              src={yobsti_logo}
              alt="Yobsti Logo"
              loading="lazy"
              className="h-12"
            />
          </NavLink>

          <nav className="hidden xl:flex flex-1 justify-center gap-8 text-md whitespace-nowrap">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} end className={activeUnderline}>
                <img src={item.icon} alt="" className="h-5" />
                {item.label}
              </NavLink>
            ))}
          </nav>

          <WhatsAppButton location="header" className="hidden xl:inline-flex" />

          <div className="flex items-center gap-2 xl:hidden">
            <a
              href={WHATSAPP_CHAT_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track('whatsapp-click', { location: 'header-mobile' })}
              className="inline-flex items-center justify-center rounded-full bg-primary p-2 text-textColor hover:bg-primaryDark"
              aria-label="Hilfe per WhatsApp"
            >
              <FaWhatsapp className="h-5 w-5" aria-hidden="true" />
            </a>
            <button
              type="button"
              className="inline-flex items-center justify-center rounded-md p-2 text-textColor hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-lineGreen"
              aria-label="Menü öffnen"
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
            >
              {open ? (
                <img src={cancel} alt="" className="h-5" />
              ) : (
                <img src={menu} alt="" className="h-5" />
              )}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="xl:hidden absolute inset-x-0 top-full bg-white border-b border-[#DFDED1] shadow dropdown">
          <div className="px-5 py-3 space-y-1">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} end className={linkBase}>
                <img src={item.icon} alt="" className="h-5" />
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
